import {
  ColorSwatch,
  Group,
  InputWrapper,
  SegmentedControl,
  Select,
  Slider,
  Stack,
  useMantineTheme,
} from '@mantine/core';
import IconCheck from '@tabler/icons-react/dist/esm/icons/IconCheck.mjs';
import { useThemeStore } from '@/mantineTheme';
import { useTranslation } from 'react-i18next';
import { omit } from 'lodash';

const iconProps = {
  stroke: 1.5,
  color: 'currentColor',
  opacity: 0.6,
  size: 18,
};
export const ThemeOptions = () => {
  const { t } = useTranslation('translation');
  const {
    defaultRadius,
    setDefaultRadius,
    primaryColor,
    setPrimaryColor,
    primaryShade,
    setPrimaryShade,
  } = useThemeStore(
    ({
      defaultRadius,
      setDefaultRadius,
      primaryColor,
      setPrimaryColor,
      primaryShade,
      setPrimaryShade,
    }) => ({
      defaultRadius,
      setDefaultRadius,
      primaryColor,
      setPrimaryColor,
      primaryShade,
      setPrimaryShade,
    }),
  );
  const theme = useMantineTheme();
  const radiusOptions = [
    { label: 'xs', value: 'xs' },
    { label: 'sm', value: 'sm' },
    { label: 'md', value: 'md' },
    { label: 'lg', value: 'lg' },
    { label: 'xl', value: 'xl' },
  ];
  const colorOptions = Object.keys(omit(theme.colors, ['dark']))
    .filter((x) => !!theme.colors[x] && !!x)
    .map((x) => ({
      label: x,
      value: x,
    }));

  return (
    <Stack>
      <InputWrapper label={t('theme.defaultRadius')}>
        <SegmentedControl
          data={radiusOptions}
          value={defaultRadius}
          fullWidth
          onChange={setDefaultRadius}
        />
      </InputWrapper>

      <Select
        data-testid='theme-primary-color-select'
        label={t('theme.defaultPrimaryColor')}
        data={colorOptions}
        value={primaryColor}
        onChange={setPrimaryColor}
        leftSection={
          <ColorSwatch
            color={`var(--mantine-color-${theme.primaryColor}-filled)`}
            size={16}
          />
        }
        renderOption={({ option, checked }) => (
          <Group flex='1' gap='xs'>
            <ColorSwatch
              color={`var(--mantine-color-${option.value}-filled)`}
            />
            {option.label}
            {checked && (
              <IconCheck style={{ marginInlineStart: 'auto' }} {...iconProps} />
            )}
          </Group>
        )}
      />

      <InputWrapper label={t('theme.defaultPrimaryShade')}>
        <Slider
          defaultValue={6}
          restrictToMarks
          min={0}
          max={9}
          marks={Array.from({ length: 10 }).map((_, index) => ({
            value: index,
          }))}
          value={primaryShade}
          onChange={setPrimaryShade}
        />
      </InputWrapper>
    </Stack>
  );
};